import { CopilotFieldRef } from './copilotField';

export enum AITaskSessionStatus {
  InProgress = 0,
  WaitingForApproval = 1,
  Completed = 2,
  Canceled = 3,
  Failed = 4,
  WaitingForAnswer = 5,
}

export enum AITaskSessionApprovalStatus {
  Pending = 1,
  ReminderQueued = 2,
  Rejected = 3,
  Executing = 4,
  Executed = 5,
  Expired = 6,
  Failed = 7,
}

export class AITaskSessionSummary {
  sessionId?: number;

  status?: AITaskSessionStatus;

  title?: string;

  lastQuestion?: string;

  contextKey?: string;

  created?: Date;

  modified?: Date;

  lastActivity?: Date;

  completed?: Date;

  canceled?: Date;

  // the field a field action started the session on; absent for every other session
  originField?: CopilotFieldRef;
}

export class AITaskSessionApproval {
  sessionId?: number;

  approvalId?: number;

  status?: AITaskSessionApprovalStatus;

  adaptiveCardBlockId?: string;
}
